// import Immutable from "immutable";
// flow-disable-next-line  //remove this comment and resolve the error instead of suppressing  it
// import type { fromJS as Immut } from "immutable";
import { test1, userData } from "./test1ActionCreator";

// const initialState = Immutable.fromJS({
//   text: "some initial txt",
//   textAsync: "textAsync initial val"
// });

const initialState = {
  text: "initial text msg",
  textAsync: "initial text async msg"
};

const testReducer = (state = initialState, action) => {
  switch (action.type) {
    case test1: {
      return Object.assign({}, state, { text: action.payload });
      // return state.set("text", action.payload);
    }
    case userData: {
      return Object.assign({}, state, { textAsync: action.payload });
      // return state.set("textAsync", action.payload);
    }
    default: {
      return state;
    }
  }
};

export default testReducer;



// WEBPACK FOOTER //
// ./app/components/containers/test1/test1Reducer.js